module.exports = __webpack_public_path__ + "image/list_img2.jpg";